import { clearAccessToken, fetchWithAuth, BASE_BACKEND_URL } from '../../auth'
import { faFilter } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect, useRef, useState, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import * as apiStatusCodes from '../../constants/apiStatusCodes'
import Pagination from '../../layout/Pagination'
import SearchInput from '../../layout/SearchInput'
import usePagination from '../../layout/usePagination'
import LoadingScreen from '../../components/LoadingScreen'
import { Table } from 'react-bootstrap'
import { useParams } from 'react-router-dom'
import { getFeatureRoles, handleErrors } from '../../config_user/services/apiUserService'

const UsersByClientRoute = () => {
  const navigate = useNavigate()
  const myRef = useRef(null)
  const { id } = useParams()

  const { pagination, setPagination, handlePaginationClick } = usePagination({
    per_page: 25,
    current_page: 1,
    total_pages: 1
  })

  const [featureRoles, setFeatureRoles] = useState([])
  const getRoleLabel = useCallback(
    (key) => featureRoles.find((e) => e.value == key)?.label,
    [featureRoles]
  )

  const [title, setTitle] = useState('Usuarios asignados: ')
  const [isFetching, setIsFetching] = useState(false)
  const [data, setData] = useState([])
  const [query, setQuery] = useState('')

  ////// Stops fetchs when page is changed
  const abortController = new AbortController()
  const abortCurrentFetchs = () => {
    abortController.abort('Fetch Aborted by User.')
  }
  window.addEventListener('beforeunload', abortCurrentFetchs)
  //////

  useEffect(() => {
    getFeatureRoles()
      .then((response) => handleErrors(response))
      .then((response) => response.json())
      .then((data) => {
        setFeatureRoles(
          data?.table?.map((e) => ({ value: e.key, role: e.name, label: e.name })) ?? []
        )
      })
      .catch((error) => {
        if (error?.status === apiStatusCodes.UNAUTHORIZED) {
          clearAccessToken()
          window.location = '/'
        }
      })
  }, [])

  useEffect(() => {
    fetchDataFromServer(pagination.current_page)
  }, [pagination.current_page])

  useEffect(() => {
    fetchDataFromServer(1)
  }, [query])

  const fetchDataFromServer = useCallback(
    async (page = 1) => {
      const per_page = pagination.per_page
      setIsFetching(true)
      try {
        const response = await fetchWithAuth(
          `${BASE_BACKEND_URL}/route_plans?users_client_route=true&client_id=${id}&page=${page}&per_page=${per_page}${query ? `&q=${encodeURIComponent(query)}` : ''}`,
          {
            method: 'GET',
            signal: abortController.signal,
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            }
          }
        )


        const data = response
        if (!data) return
        setPagination((prev) => ({
          ...prev,
          total_pages: Math.ceil(data['count'] / prev.per_page)
        }))
        setData(data['result'])
        setTitle(`Usuarios asignados: ${data['client_uid']} - ${data['client_name']}`)
      } catch (error) {
        if (error !== 'Fetch Aborted by User.') {
          console.error('Error:', error)
        }
      }
      setIsFetching(false)
    },
    [pagination.current_page, query]
  )

  const handleSearch = (newQuery) => {
    setQuery(newQuery)
  }

  const handleShowUserDetails = (event) => {
    event.preventDefault()
    const id = event.target.id
    navigate(`/usuarios/${id}`)
  }

  if (isFetching) {
    return <LoadingScreen text="Cargando ..." />
  }

  return (
    <div>
      <div>
        <div ref={myRef}>
          <div className="index-header detailed-container">
            <h2>{title}</h2>
          </div>

          <div className="index-table">
            <div className="show-area">
              <div className="filters-search-container mb-search-user">
                <h4 className="text-sub-title">Listado de usuarios:</h4>
                <div className="search-input-containter">
                  <SearchInput
                    query={query}
                    onSearch={handleSearch}
                    placeholder="Buscar usuarios por nombre o código"
                  />
                </div>
              </div>
              <br />
              <div>
                <Table hover responsive>
                  <thead className="table-header-gray">
                    <tr>
                      <th style={{ verticalAlign: 'middle', padding: '10px 25px' }}>
                        <span className="th-header-text">CÓDIGO</span>
                      </th>
                      <th style={{ verticalAlign: 'middle' }}>
                        <span className="th-header-text">NOMBRE</span>
                      </th>
                      <th style={{ verticalAlign: 'middle' }}>
                        <span className="th-header-text">ROL DE USUARIO</span>
                      </th>
                      <th style={{ verticalAlign: 'middle' }}>
                        <span className="th-header-text">PLAN DE VISITA ASIGNADO</span>
                      </th>
                      <th style={{ verticalAlign: 'middle' }}>
                        <span className="th-header-text">CORREO ELECTRONICO</span>
                      </th>{' '}
                      <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>
                        <span className="th-header-text">ACTIVO</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.length > 0 &&
                      data?.map((user, index) => (
                        <tr key={user.id}>
                          <td
                            className="td-text-limited td-text-limited-space"
                            id={user['id']}
                            onClick={handleShowUserDetails}
                          >
                            {user['route_db_ref']}
                          </td>
                          <td
                            className="td-text-limited"
                            id={user['id']}
                            onClick={handleShowUserDetails}
                          >
                            {user['full_name']}
                          </td>
                          <td
                            className="td-text-limited"
                            id={user['id']}
                            onClick={handleShowUserDetails}
                          >
                            {user['roles']?.map((e) => getRoleLabel(e.feature_role_key)).join(', ')}
                          </td>
                          <td
                            className="td-text-limited"
                            id={user['id']}
                            onClick={handleShowUserDetails}
                          >
                            {user['route_plan_title'] || '-'}
                          </td>
                          <td
                            className="td-text-limited"
                            id={user['id']}
                            onClick={handleShowUserDetails}
                          >
                            {user['email']}
                          </td>
                          <td
                            className="td-text-limited centered-text"
                            id={user['id']}
                            onClick={handleShowUserDetails}
                          >
                            {user['active'] ? 'Si' : 'No'}
                          </td>
                        </tr>
                      ))}
                    {!isFetching && (data?.length === 0 || !data) && (
                      <tr>
                        <td colSpan="5" className="td-text-limited td-text-limited-space">
                          No hay resultados
                        </td>
                      </tr>
                    )}

                    {isFetching && (
                      <tr>
                        <td className="td-text-limited" colSpan="5">
                          Obteniendo datos...
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>

              {pagination.total_pages > 1 && (
                <nav className="index-table" onClick={handlePaginationClick}>
                  <Pagination
                    current_page={pagination.current_page}
                    total_pages={pagination.total_pages}
                  />
                </nav>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UsersByClientRoute
